<app-view (bannerCreated)="submitBanner($event)" [buttonLabel]="'Submit'"></app-view>